import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 32EF139A-14EB-4767-ADDD-08120FB530A0
 * name home-roof
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-roof.svg
 * tags
 * - Home Automation 
 */
export const HomeRoofIcon = createSvgIcon(<><path d="M19 16H22L12 7L2 16H5L12 9.69L19 16M7 8.81V7H4V11.5L7 8.81Z" /></>, 'HomeRoofIcon');
export default HomeRoofIcon